module.exports = __webpack_public_path__ + "assets/all_followed.png";